import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Tooltip,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownloadOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import '../tablestyle.css'; // Create this CSS file for custom styles
import LedgerAccountDetails from "./LedgerAccountDetails";


var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var token= ''
var sacco= ''
var bizuserid= ''


class ReportToPrint extends React.Component {

    state = {
      companyprofile:{}
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })
  
    }



    calculateTotal=(list)=>{
      var total =0
      list.map((item)=>{
        total+=Number(item.balance)
      })
      return total.toFixed(2);
    }
    


  
    render() {
      return (
        <div style={{padding:20}}>
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h5>{this.state.companyprofile.companydealership}</h5>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
              
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

           </Row>

             <h3 style={{display: 'flex',justifyContent:'center', alignItems:'center',fontWeight:'bolder'}}>STATEMENT OF PROFIT OR LOSS & OTHER COMPREHENSIVE INCOME FROM {this.props.dateone}  TO {this.props.datetwo}</h3>

             <Divider></Divider>

<h5 style={{}}>INCOME</h5>

 {
   this.props.balancesheet_report_incomes.map((catgry)=>{
   return (

       <reactstrp.Table bordered>
             <thead>

               <tr >
                 <th>{catgry.chatofaccounts_subcategory}</th>
                 <th>{<CurrencyFormat value={this.calculateTotal(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</th>
               </tr>
             </thead>

      </reactstrp.Table>

      


   );

 })
}

<Divider></Divider>
<reactstrp.Table bordered>
         <thead>
         <tr>
           <th>TOTAL</th>
           <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.props.AllTotals)==="{}"?0:Number(this.props.AllTotals.total_balances_incomes)} displayType={'text'} thousandSeparator={true}/>}</th>
           </tr>
         </thead>
 </reactstrp.Table> 


<Divider></Divider>

<h5 style={{}}>EXPENDITURE</h5>
{
 this.props.balancesheet_report_expenses.map((catgry)=>{
   return (
   
       <reactstrp.Table bordered>
             <thead>

               <tr >
                 <th>{catgry.chatofaccounts_subcategory}</th>
                 <th>{<CurrencyFormat value={this.calculateTotal(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</th>
               </tr>
          </thead>
       </reactstrp.Table>

   );

 })
}



<Divider></Divider>
<reactstrp.Table bordered>
         <thead>
         <tr>
           <th>TOTAL</th>
           <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.props.AllTotals)==="{}"?0:Number(this.props.AllTotals.total_balances_expense)} displayType={'text'} thousandSeparator={true}/>}</th>
           </tr>
         </thead>
 </reactstrp.Table> 


  <br></br> 
 <Divider  dashed />

 <reactstrp.Table bordered>
         <thead>
         <tr>
           <th>Net Profit for The Period</th>
           <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.props.AllTotals)==="{}"?0:Number(this.props.AllTotals.surplus)} displayType={'text'} thousandSeparator={true}/>}</th>
           </tr>
         </thead>
 </reactstrp.Table> 

 
        </div>
      );
    }
  }


class IncomeStatementsView_f1 extends React.Component {

  state = {
   expenses:[],
   incomes:[],
   dateone:'',
   datetwo:'',
   totalincomes:0,
   totalexpenses:0,
   surplus:0,
   datarequested:false,

   ledeger_details_model_visible:false,
   selected_record:{},


   balancesheet_report_incomes:[],
   balancesheet_report_expenses:[],
   AllTotals:{},

   seleted_category:'',
   show_category_details:false



  };

  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

  }

  handledatechange= (date, dateString) =>{
    this.setState({ dateone: dateString[0]});
    this.setState({ datetwo: dateString[1]});
  } 

 

  //search incomes method
  getstatement=()=>{
   let form_data = new FormData();
   form_data.append('dateone', this.state.dateone);
   form_data.append('datetwo', this.state.datetwo);
   form_data.append('sacco', sacco);
   
   if(this.state.dateone===''||this.state.datetwo===''){
    alert("Please are dates missing")
   }else{
    this.setState({datarequested:true})

       //Now submit sale data to database
       axios.post(serverconfig.backendserverurl+'/customqueries/getincomestatement_f1', form_data,{
        headers: {
          'content-type': 'multipart/form-data'
        }
         })
         .then(res =>{
           this.setState({datarequested:false})
 
            this.setState({balancesheet_report_expenses:JSON.parse(res.data.balancesheet_report_expenses)})
            this.setState({balancesheet_report_incomes:JSON.parse(res.data.balancesheet_report_incomes)})

            this.setState({AllTotals:res.data.AllTotals})
         } 
         )
         .catch(error => console.log(error)) 
   }

   }


calculateTotal=(list)=>{
  var total =0
  list.map((item)=>{
    total+=Number(item.balance)
  })
  return total.toFixed(2);
}





  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {
      
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
          <div style={{display: "none"}}>
             &nbsp;&nbsp;

            <ReportToPrint
            dateone={this.state.dateone}
            datetwo={this.state.datetwo}
            balancesheet_report_expenses={this.state.balancesheet_report_expenses}
            balancesheet_report_incomes={this.state.balancesheet_report_incomes}
            ref={el => (this.componentRef = el)}
            AllTotals={this.state.AllTotals}
            /> 


          </div>

            <div>


            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>

              <ReactToPrint
              trigger={() => 
              <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
              Print
              </Button>
              }
              content={() => this.componentRef}
              />
              &nbsp;
              &nbsp;

            <Form  layout="inline" >
                <FormItem label="Date Range">
                    <RangePicker defaultValue={moment()} onChange={this.handledatechange} format={dateFormat} />
                </FormItem>

                <FormItem>
                <Button onClick={this.getstatement} type="primary" htmlType="button">Search</Button>
                </FormItem> 

            </Form>

            </div>
            <Divider></Divider>

             <h5 style={{}}>INCOME</h5>
            
              {
                this.state.balancesheet_report_incomes.map((catgry)=>{
                return (
                  <div>

                    <reactstrp.Table bordered>
                          <thead>
                          <Tooltip title="Click to view details" placement="top">

                            <tr onClick={()=>{
                              this.setState({seleted_category:catgry.chatofaccounts_subcategory})
                              this.setState({show_category_details:!this.state.show_category_details})
                              }}>
                              <th>{catgry.chatofaccounts_subcategory}</th>
                              <th>{<CurrencyFormat value={this.calculateTotal(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</th>
                            </tr>
                            </Tooltip>
                          </thead>

                   </reactstrp.Table>

                    {
                      catgry.report.length>0 && this.state.seleted_category===catgry.chatofaccounts_subcategory && this.state.show_category_details===true?
                      <div>
                        <reactstrp.Table bordered>
                          <thead>
                            <tr>
                              <th>Account</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              catgry.report.map((item)=>(
                              <Tooltip title="Click to view details" placement="top">
                                <tr onClick={()=>{
                                  this.setState({selected_record:item})
                                  this.setState({ledeger_details_model_visible:true})
                                  }}> 
                                  <td>{item.account}</td>
                                <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                </tr>
                                </Tooltip>
                              ))
                            }


                            </tbody>
                           </reactstrp.Table> 
                      </div>
                      :
                      null
                    }


                  </div>
                );

              })
            }

      <Divider></Divider>
          <reactstrp.Table bordered>
                      <thead>
                      <tr>
                        <th>TOTAL</th>
                        <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.state.AllTotals)==="{}"?0:Number(this.state.AllTotals.total_balances_incomes)} displayType={'text'} thousandSeparator={true}/>}</th>
                        </tr>
                      </thead>
              </reactstrp.Table> 


          <Divider></Divider>

          <h5 style={{}}>EXPENDITURE</h5>
          {
              this.state.balancesheet_report_expenses.map((catgry)=>{
                return (
                  <div>
                
                    <reactstrp.Table bordered>
                          <thead>
                          <Tooltip title="Click to view details" placement="top">

                            <tr onClick={()=>{
                              this.setState({seleted_category:catgry.chatofaccounts_subcategory})
                              this.setState({show_category_details:!this.state.show_category_details})

                              }}>
                              <th>{catgry.chatofaccounts_subcategory}</th>
                              <th>{<CurrencyFormat value={this.calculateTotal(catgry.report)} displayType={'text'} thousandSeparator={true}/>}</th>
                            </tr>
                            </Tooltip>
                       </thead>
                    </reactstrp.Table>

                    {
                      catgry.report.length>0 && this.state.seleted_category===catgry.chatofaccounts_subcategory && this.state.show_category_details===true?
                      <div>
                        <reactstrp.Table bordered>
                          <thead>
                            <tr>
                              <th>Account</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              catgry.report.map((item)=>(
                              <Tooltip title="Click to view details" placement="top">
                                <tr onClick={()=>{
                                  this.setState({selected_record:item})
                                  this.setState({ledeger_details_model_visible:true})
                                  }}> 
                                  <td>{item.account}</td>
                                <td className="align-right">{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>
                                </tr>
                                </Tooltip>
                              ))
                            }
                         
                            </tbody>
                           </reactstrp.Table> 

                      </div>
                      :
                      null
                    }


                  </div>
                );

              })
            }



          <Divider></Divider>
          <reactstrp.Table bordered>
                      <thead>
                      <tr>
                        <th>TOTAL</th>
                        <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.state.AllTotals)==="{}"?0:Number(this.state.AllTotals.total_balances_expense)} displayType={'text'} thousandSeparator={true}/>}</th>
                        </tr>
                      </thead>
              </reactstrp.Table> 


               <br></br> 
              <Divider  dashed />

              <reactstrp.Table bordered>
                      <thead>
                      <tr>
                        <th>Net Profit for The Period</th>
                        <th className="align-right"style={{fontWeight:'bolder'}}>{<CurrencyFormat value={JSON.stringify(this.state.AllTotals)==="{}"?0:Number(this.state.AllTotals.surplus)} displayType={'text'} thousandSeparator={true}/>}</th>
                        </tr>
                      </thead>
              </reactstrp.Table> 

        </div>
        <br></br>


        {
        this.state.ledeger_details_model_visible===true?

          <Modal    
              visible={this.state.ledeger_details_model_visible}
              title="Account details view"
              onCancel={()=>{this.setState({ledeger_details_model_visible:false})}}
              footer={[
                <Button key="back" onClick={()=>{this.setState({ledeger_details_model_visible:false})}}>
                  Cancel
                </Button>
                ]}
                width={1000}
                >
                    <LedgerAccountDetails
                    dateone={this.state.dateone}
                    datetwo={this.state.datetwo}
                    account={this.state.selected_record.account}
                    />
                  
            </Modal>
              :
              null
            }

        </div>
    )}
    
  }
}

export default IncomeStatementsView_f1; 
